import { Injectable } from '@angular/core';

import { isPolicyAllowed } from '@core/application/use-cases/user-consent/check-policy-allowed.use-case';
import { userConsentPolicies } from '@core/domain/constants/user-consent.const';
import { AttachmentCategory, Category } from '@core/domain/models/category.models';
import { CoreOneTrustService } from '@core/infrastructure/one-trust/one-trust.service';
import { CorePlatformService } from '@core/infrastructure/platform/platform.service';
import { CoreStorageService } from '@core/infrastructure/storage/storage.service';
import { CategoryPublicModels } from '@features/category';

@Injectable()
export class HeraclesService {
    private readonly sessionStorageKey = 'heracles';

    constructor(
        private readonly storageService: CoreStorageService,
        private readonly platformService: CorePlatformService,
        private readonly oneTrustService: CoreOneTrustService
    ) { }

    public getHeraclesCategoryId(category: Category | CategoryPublicModels.PublicMenuCategory): string | null {
        if (!isPolicyAllowed(this.platformService, this.oneTrustService, userConsentPolicies.FUNCTIONAL_PERSONALIZATION)) {
            return null;
        }

        if (!category?.attachments?.length) {
            return null;
        }

        const heraclesAttachment = category.attachments.filter((attachment: AttachmentCategory) => {
            return attachment.name?.includes(this.sessionStorageKey.toUpperCase());
        });

        if (!heraclesAttachment.length) {
            return null;
        }

        // Caso parrilla manual
        let categoryResultId = null;

        const categoryId = heraclesAttachment[0].path.split('_')[1];
        let sessionHeracles = undefined;
        const heraclesKey = `${this.sessionStorageKey}_${category.id}`;

        sessionHeracles = this.storageService.getValue<string>(heraclesKey, 'SESSION');

        // Caso categoría principal en session storage
        if (sessionHeracles) {
            // Caso parrilla heracles
            if (sessionHeracles.value === this.sessionStorageKey) {
                categoryResultId = sessionHeracles.heraclesId;
            }
        } else {
            // Caso categoría principal no se encuentra en session storage
            // eslint-disable-next-line no-lonely-if
            if (Math.floor(Math.random() * 2) === 1) {
                // Caso parrilla heracles
                this.storageService.setValue(heraclesKey, { value: this.sessionStorageKey, heraclesId: categoryId, categoryId: category.id }, 'SESSION', 'TECHNICAL');
                categoryResultId = categoryId;
            } else {
                // Caso parrilla manual
                this.storageService.setValue(heraclesKey, { value: 'manual' }, 'SESSION', 'TECHNICAL');
            }
        }

        return categoryResultId;
    }
}
